/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };


  growApp.prototype.newsSelect = function () {
    // トップページのセレクトボタン
    // $('.c-block-news-select__block.s0').show();
    // $('.c-block-news-select__select-box').change(function () {
    //   var val = $('.c-block-news-select__select-box option:selected').val();
    //   if (val == '.c-block-news-select__select-box') return;
    //   $('.c-block-news-select__block').hide();
    //   $('.c-block-news-select__block.' + val).show();
    // });
  };


  /************************
   * please insert your code
   *************************/
  growApp.prototype.mapSearch = function () {
    return false;
    if (typeof google === "undefined" || $('#map').length === 0) {
      return false;
    }

    //初期化
    var map, toggle, markers = [];
    // 仮のjsonデータ
    var datalist = [
      {
        "name": "新極真会支部",
        "address": "〒171-0021<br>東京都豊島区西池袋2-38-1",
        "tel": "03-5992-9200",
        "lat": "35.727587",
        "lng": "139.7052899",
      },
      {
        "name": "新極真会支部2",
        "address": "〒171-0021<br>東京都豊島区西池袋2-38-1",
        "tel": "03-5992-9200",
        "lat": "35.5825555",
        "lng": "139.3376042",
      },
      {
        "name": "新極真会支部3",
        "address": "〒171-0021<br>東京都豊島区西池袋2-38-1",
        "tel": "03-5992-9200",
        "lat": "35.685555",
        "lng": "139.7386042",
      },
      {
        "name": "新極真会支部4",
        "address": "〒171-0021<br>東京都豊島区西池袋2-38-1",
        "tel": "03-5992-9200",
        "lat": "35.655555",
        "lng": "139.7686042",
      },
      {
        "name": "新極真会支部5",
        "address": "〒171-0021<br>東京都豊島区西池袋2-38-1",
        "tel": "03-5992-9200",
        "lat": "35.695555",
        "lng": "139.7186042",
      },
    ];
    if (window.facilitydata) {
      datalist = window.facilitydata;
    }


    //Mapの描画
    /*-------------------------------------------------------------------*/
    function initMap() {
      map = new google.maps.Map(document.getElementById('map'), {
        center: {
          lat: 35.727587,
          lng: 139.7052899,
        },
        zoom: 7,
        zoomControl: true,
        disableDoubleClickZoom: true,
        mapTypeControl: true,
        scaleControl: true,
        scrollwheel: false,
        panControl: true,
        streetViewControl: true,
        draggable: true,
        overviewMapControl: true,
        overviewMapControlOptions: {
          opened: false,
        },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });

      if (datalist.length < 2) {
        map.setZoom(12);
      } else {
        map.setZoom(7);
      }
    }

    //JSONデータ分、ピンをさして、ウィンドウを作成する
    /*-------------------------------------------------------------------*/
    function addMarkerPosition() {
      var $_html = null;

      var markerBounds = new google.maps.LatLngBounds();
      //順番に処理開始
      for (var i = 0; i < datalist.length; i++) {
        var latlng = {
          lat: datalist[i]['lat'] - 0,
          lng: datalist[i]['lng'] - 0,
        };

        //吹き出しをセット
        $_html = $('<div><div class="c-googletooltip is-tips">' +
          '<div class="c-googletooltip__name">' + datalist[i].name + '</div>' +
          '<div class="c-googletooltip__text">' + datalist[i].address + '</div>' +
          '<div class="c-googletooltip__tel">' + datalist[i].tel + '</div>');
        var infowindow = new google.maps.InfoWindow({
          content: $_html.html(),
          disableAutoPan: false
        });

        //マーカーをセット
        var marker = new google.maps.Marker({
          position: latlng,
          map: map,
        });

        markers[i] = marker;
        markers[i]["infowindow"] = infowindow;

        marker.setMap(map);
        markerBounds.extend(latlng);

        // クリック時に外のinfoWindowをすべて閉じて開く
        google.maps.event.addListener(marker, 'click', function () {
          if (0 === toggle) {
            for (var i = 0; i < markers.length; i++) {
              var currentMaker = markers[i];
              currentMaker['infowindow'].close();
            }

            infowindow.setContent(this.infowindow.content);
            infowindow.open(map, this);
            map.setCenter(this.getPosition());
            toggle = 1;

          } else {
            infowindow.close();
            toggle = 0;
            infowindow.setContent(this.infowindow.content);
            infowindow.open(map, this);
            map.setCenter(this.getPosition());
          }
        });


        //座標を配列に格納
        var latlng_data = [];
        latlng_data.push(latlng);
      }

      map.fitBounds(markerBounds);

      if (datalist.length === 1) {
        var listener = google.maps.event.addListener(map, "idle", function () {
          map.setZoom(18);
          google.maps.event.removeListener(listener);
        });
      } else {
        map.fitBounds(markerBounds);
      }

      //センターへ移動
      // google.maps.setCenter(new google.maps.LatLng(latlng_data[0].lat, latlng_data[0].lng ));
    }


    //Mapの描画とマーカーピンをさして、ウィンドウを作成する
    function runInitMap() {
      initMap();
      addMarkerPosition();
    }

    runInitMap();
  };

  $(function () {
    var app = new growApp();
    app.mapSearch();
    app.newsSelect();
  });

})(jQuery);
